import constant from '../constants/uiConstant';

export const uiInitialState = {
    activeMenuItem: localStorage.getItem("should-finish-active-item") ?? ""
}

export function uiReducer(state, action) {

    switch (action.type) {

        case constant.SET_SIDE_MENU_ACTIVE_ITEM:
            return {
                ...state,
                activeMenuItem: action.payload
            };

        default:
            return state;
    }
}

export default uiReducer;
